import { makeStyles } from 'tss-react/mui';
import { CommonColors, PaletteColor } from '@mui/material/styles/createPalette';
import { CSSObject } from 'tss-react';


const eventLeftBorderStyleMixin = (color: PaletteColor): CSSObject => ({
  borderLeftWidth: '4px',
  borderLeftColor: color.border,
  borderLeftStyle: 'solid',
});

const eventBackgroundStyleMixin = (color: PaletteColor, withLeftBorder = true): CSSObject => ({
  background: color.background,
  color: color.dark,
  boxSizing: 'border-box',
  ...(withLeftBorder ? eventLeftBorderStyleMixin(color) : {}),
});


const eventStyleMixin = (color: PaletteColor, common: CommonColors): CSSObject => ({
  background: color.main,
  color: common.white,
});


export const useStyles = makeStyles<{ compact: boolean }>()((theme, { compact }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    border: '1px solid #fff',
    borderRadius: theme.spacing(0.5),
    boxSizing: 'border-box',
    padding: compact ? '1px 7px' : '0px 8px',
    cursor: 'pointer',
    minHeight: '14px',

    boxShadow: theme.shadows[0],
    transitionDuration: '200ms',
  },

  startTimeWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flex: 1,
    height: compact ? '100%' : 'auto',
  },

  startTime: {
    fontSize: '10px',
    lineHeight: compact ? '100%' : '14px',
    whiteSpace: 'nowrap',
    opacity: 0.9,
  },

  timeUsername: {
    fontSize: '10px',
    lineHeight: compact ? '100%' : '14px',
    whiteSpace: 'nowrap',
    paddingRight: '2px',
    fontWeight: 500,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  indicator: {
    height: '14px',
    width: '14px',
  },

  username: {
    fontSize: '14px',
    lineHeight: compact ? '100%' : '17px',
    fontWeight: 450,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1),
  },

  extraContainer: {
    display: 'flex',
    whiteSpace: 'nowrap',
    justifyContent: 'center',
    alignItems: 'center',
  },

  indicatorTitle: {
    fontSize: '11px',
    margin: 0,
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },

  noTopBorderRadius: {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },

  noBottomBorderRadius: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },

  variantAppointment: eventStyleMixin(theme.palette.secondary, theme.palette.common),
  variantAppointmentWarning: eventStyleMixin(theme.palette.warning, theme.palette.common),
  variantAppointmentOverlapWarning: {
    ...eventStyleMixin(theme.palette.warning, theme.palette.common),
    backgroundImage: `repeating-linear-gradient(135deg,
      ${theme.palette.warning.main},
      ${theme.palette.warning.main} 8px,
      ${theme.palette.warning.dark} 8px,
      ${theme.palette.warning.dark} 12px
    )`,
  },
  variantAvailability: eventBackgroundStyleMixin(theme.palette.secondary),
  variantAvailabilityWarning: eventBackgroundStyleMixin(theme.palette.warning),
  variantIcs: {
    boxSizing: 'border-box',
    background: theme.palette.info.background,
    color: theme.palette.text.primary,
  },
  variantOutOfOffice: {
    background: '#a6de9b',
    color: theme.palette.success.darkText,
    boxSizing: 'border-box',
  },

  elevation: {
    boxShadow: theme.shadows[20],
  },
  elevationLow: {
    boxShadow: theme.shadows[3],
  }
}));
